<template>
  <div>
    <div v-if="actionProducts.length">
      <ul
        class="flex flex-wrap"
      >
        <li
          v-for="product in actionProducts"
          :key="`product-${product.id}`"
          class="w-1/2 lg:w-1/4 flex"
        >
          <transition
            name="zoom-out-fade"
            appear
          >
            <button
              class="config-btn text-gray-700 mx-1 w-full cursor-pointer mx-2 my-2 md:h-48"
              @click="openModal(product)"
            >
              <div class="mb-3 h-24">
                <img
                  class="h-24"
                  :src="product.photo_url"
                  :alt="product.name"
                >
              </div>
              <span class="text-xs sm:text-base md:text-lg">{{ name(product) ? stringLimit(name(product), 36) : '-' }}</span>
            </button>
          </transition>
        </li>
      </ul>
    </div>
    <div
      v-else
      class="products__no-results"
    >
      {{ $t('team.noResults') }}
    </div>
    <transition name="modal">
      <BaseModal
        v-if="modalVisible"
        @close="closeModal"
      >
        <div class="product-modal">
          <div class="product-modal__image">
            <img
              :src="modalData.photo_url"
              :alt="`action-${modalData.action_id}`"
            >
          </div>
          <div class="product-modal__desc">
            <div v-html="sanitizeHtml(description(modalData))" />
          </div>
        </div>
      </BaseModal>
    </transition>
  </div>
</template>
<script>
import { stringLimit } from '@/utils/stringLimit';
import sanitize from '@/utils/sanitizeHtml';
import BaseModal from '@/components/BaseModal';
import name from '@/mixins/name';
import description from '@/mixins/description';

export default {
  name: 'ActionProducts',
  components: {
    BaseModal,
  },
  mixins: [name, description],
  props: {
    actionProducts: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      modalVisible: false,
      modalData: null,
    };
  },
  methods: {
    ...sanitize,
    stringLimit,
    openModal(data) {
      this.modalData = data;
      this.modalVisible = true;
    },
    closeModal() {
      this.modalVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.products {
  &__no-results {
    @apply pt-1 text-sm text-center;
  }
}

.product-modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  &__image {
    max-width: 300px;
  }
  &__desc {
    @apply pt-6 text-justify text-sm;
    @screen sm {
      @apply text-base;
    }
  }
}
</style>
